import styled from "styled-components";
import { Title } from "../typography/Title";

const StyledFormSectionHeadline = styled(Title).attrs({ level: 5 })``;

const FormSectionHeadline = StyledFormSectionHeadline;

export { FormSectionHeadline };
